import * as actionTypes from './actionTypes';

export const setRuleToUpdate=(rule)=>({
    type:actionTypes.SET_RULE_TO_UPDATE,
    payload:rule
})